import { FeatureCategory } from '../types';

export const integrationsFeatures: FeatureCategory = {
  name: "Integrations & Smart Home",
  icon: "Wifi",
  features: [
    { 
      name: "Oura Ring Sync", 
      description: "Automatically sync sleep quality, resting heart rate, and activity data from your Oura Ring into your wellness dashboard.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Fitbit Sync",
      description: "Connect your Fitbit to sync steps, heart rate, sleep, weight, and SpO2 data directly into your daily wellness view.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Withings Sync",
      description: "Sync weight, blood pressure, and sleep data from Withings smart scales, monitors, and sleep trackers.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Multi-Device Source Intelligence",
      description: "When multiple wearables are connected, SeniorThrive automatically selects the most accurate source for each metric, so your numbers stay stable and trustworthy.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Google Calendar Sync",
      description: "Sync appointments, medication reminders, and care visits with Google Calendar to keep your schedule in one place.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Apple Calendar Sync",
      description: "Connect with Apple Calendar for seamless scheduling of care tasks, visits, and health appointments.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Alexa Voice Integration",
      description: "Use Amazon Alexa to check your ThriveScore, hear medication reminders, and get daily wellness updates hands-free.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Google Home Integration",
      description: "Ask Google Home for your daily check-in summary, care schedule, and safety reminders throughout the day.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
  ]
};
